import { createClient } from '@supabase/supabase-js';
import { Capacitor } from '@capacitor/core';

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || '';
const SUPABASE_KEY = process.env.REACT_APP_SUPABASE_KEY || '';
const IS_CAPACITOR_ANDROID = Capacitor?.getPlatform?.() === 'android'
  || (typeof window !== 'undefined' && window?.Capacitor?.platform === 'android');

if (process.env.NODE_ENV !== 'production') {
  console.log('Supabase URL:', process.env.REACT_APP_SUPABASE_URL ? 'OK' : 'MISSING');
  console.log('Supabase KEY:', process.env.REACT_APP_SUPABASE_KEY ? 'OK' : 'MISSING');
}

let _client = null;
export const getSupabase = () => {
  if (!_client && SUPABASE_URL && SUPABASE_KEY) {
    _client = createClient(SUPABASE_URL, SUPABASE_KEY, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: !IS_CAPACITOR_ANDROID,
        storage: window.localStorage,
        flowType: 'pkce',
      },
    });
  }
  return _client;
};

export const supabase = getSupabase();
export const SUPABASE_ENABLED = !!supabase;
